import { render, staticRenderFns } from "./OnboardingEmailVerifyPage.vue?vue&type=template&id=5f54b6ea&scoped=true&"
import script from "./OnboardingEmailVerifyPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingEmailVerifyPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingEmailVerifyPage.vue?vue&type=style&index=0&id=5f54b6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f54b6ea",
  null
  
)

export default component.exports